import { Box, Divider, Link, Paper, Stack, Typography } from "@mui/material";
import logoCropped from "../assets/wishlist-manager-logo-cropped.png";
import { APP_VERSION } from "../version";
import GoHomeButton from "./GoHomeButton";

export default function About({ onNavigateHome, onNavigate = () => {} }) {
  return (
    <Paper elevation={2} className="page-card" sx={{ p: 3, mt: 3, mb: 4 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
        <Typography variant="h5" className="section-header">
          About
        </Typography>
        <GoHomeButton onNavigateHome={onNavigateHome} />
      </Stack>

      <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
        <Box
          component="img"
          src={logoCropped}
          alt="Wishlist Manager"
          sx={{ width: { xs: 100, sm: 160 }, height: "auto" }}
        />
      </Box>

      <Typography variant="subtitle1" align="center" sx={{ color: "text.secondary", mb: 2 }}>
        A Christmas-themed family gift wishlist manager
      </Typography>

      <Typography variant="body2" align="center" sx={{ mb: 3 }}>
        Version {APP_VERSION}
      </Typography>

      <Divider sx={{ my: 2 }} />

      <Typography variant="body1" sx={{ mb: 2 }}>
        This app stores the names, wishlist items, and claim status your family group enters.
        That information is only visible to members of your own group — it's never shared
        outside it.
      </Typography>

      <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
        Built with React, MUI, and Supabase.
      </Typography>

      <Divider sx={{ my: 2 }} />

      <Typography variant="body1" sx={{ mb: 1 }}>
        Questions or feedback? Use the Send Feedback box on the Messages screen.
      </Typography>

      <Divider sx={{ my: 2 }} />
      <Stack direction="row" spacing={2} justifyContent="center" sx={{ mb: 1 }}>
        <Link component="button" variant="body2" onClick={() => onNavigate("terms")}>Terms of Service</Link>
        <Link component="button" variant="body2" onClick={() => onNavigate("privacy")}>Privacy Policy</Link>
      </Stack>

      <Typography variant="caption" align="center" sx={{ display: "block", color: "text.secondary", mt: 2 }}>
        © {new Date().getFullYear()} LostNSound Enterprises
      </Typography>
    </Paper>
  );
}
